import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { cookiePolicyAnimation } from './cookie-policy.animations';

@Component({
  selector: 'hs-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  animations: [cookiePolicyAnimation]
})
export class CookiePolicyComponent implements OnInit {

  @Input() cookiePolicyMessage: string;
  @Input() accepted: boolean;
  @Output() accept = new EventEmitter();

  constructor() { }

  ngOnInit() {

  }

  onAccept() {
    this.accept.emit();
  }

}
